// Agrega un dia a la fecha para indicar el cierre de inscripcion al usuario NO MODIFICAR !!!
export function calculoFechasAdd (objFecha: Date) {

    const fechaResultadoAdd = new Date(objFecha);
    fechaResultadoAdd.setDate(fechaResultadoAdd.getDate() + 1);

    return fechaResultadoAdd;
};

export function calculoFechas (objFecha: any) {
    let newDate = new Date(objFecha),
        nYear = newDate.getFullYear(),
        nMonth: any = newDate.getMonth() + 1,
        nDate: any = newDate.getDate();

    if (nDate < 10) { nDate = '0' + nDate; };
    if (nMonth < 10) { nMonth = '0' + nMonth; };

    const fechaResultado = nDate + '/' + nMonth + '/' + nYear;

    return fechaResultado;
};

export function calculoFechasStandar (objFecha: any) {
    let newDate = new Date(objFecha),
        nYear = newDate.getFullYear(),
        nMonth: any = newDate.getMonth() + 1,
        nDate: any = newDate.getDate();

    if (nDate < 10) { nDate = '0' + nDate; };
    if (nMonth < 10) { nMonth = '0' + nMonth; };

    const fechaResultado = nDate + '-' + nMonth + '-' + nYear;

    return fechaResultado;
};

export function calculoFechasControl (objFecha: any) {
    let newDate = new Date(objFecha),
        nYear = newDate.getFullYear(),
        nMonth: any = newDate.getMonth() + 1,
        nDate: any = newDate.getDate();

    if (nDate < 10) { nDate = '0' + nDate; };
    if (nMonth < 10) { nMonth = '0' + nMonth; };

    const fechaResultado = nYear + '-' + nMonth + '-' + nDate;
    return fechaResultado;
};